import React, { useEffect, useRef } from 'react';

const VideoComponent = () => {
    const videoRef = useRef(null);
    const reelClickedRef = useRef(false);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        videoElement.play();
                        document.body.classList.add('siteOnVideo');
                    } else {
                        videoElement.pause();
                        document.body.classList.remove('siteOnVideo');
                    }
                });
            },
            { threshold: 0.25 }
        );

        observer.observe(videoElement);

        return () => {
            observer.unobserve(videoElement);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (reelClickedRef.current) {
                if (window.scrollY < 50) {
                    document.body.classList.add('bodyOnReel');
                } else {
                    document.body.classList.remove('bodyOnReel');
                    reelClickedRef.current = false;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const base = `${process.env.PUBLIC_URL}/videos`;

    return (
        <section className='videoHome' name='home'>
            <div id="videoIndex" className="videoIndex">
                <video
                    ref={videoRef}
                    preload="metadata"
                    poster={`${base}/index-desktop.webp`} 
                    muted
                    loop
                    playsInline
                >
                    <source
                        src={`${base}/index-mobile.mp4`}
                        media="(max-width: 768px)"
                        type="video/mp4"
                    />

                    <source
                        src={`${base}/index-desktop.mp4`}
                        media="(min-width: 769px)"
                        type="video/mp4"
                    />
                </video>
            </div>
        </section>
    );
};

export default VideoComponent;